
function getMonthEnd() {
  const now = new Date();

  // Next month first date
  const nextMonth = new Date(now.getFullYear(), now.getMonth() + 1, 1);

  // Month end = next month - 1 second
  return new Date(nextMonth - 1000);
}

function updateCountdown() {
  const now = new Date().getTime();
  const end = getMonthEnd().getTime();

  const diff = end - now;

  if (diff <= 0) return;

  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
  const minutes = Math.floor((diff / (1000 * 60)) % 60);
  const seconds = Math.floor((diff / 1000) % 60);

  document.getElementById("days").innerText = String(days).padStart(2, '0');
  document.getElementById("hours").innerText = String(hours).padStart(2, '0');
  document.getElementById("minutes").innerText = String(minutes).padStart(2, '0');
  document.getElementById("seconds").innerText = String(seconds).padStart(2, '0');
}

// Run every second
setInterval(updateCountdown, 1000);
updateCountdown();